module.exports = __webpack_public_path__ + "img/6-3.532b4fab.png";